import { useContextMatchParams } from 'contexts/matchParams';
import { useContextResultOrigin } from 'contexts/resultOrigin';

import { politicalParties } from 'constants/api';
import { PATH, TYPES } from 'envs';

export function useGetMatchPartiesPath(year) {
  const { matchParams } = useContextMatchParams();
  const { allMap, type, subtype, town, province, community } = matchParams;
  const isAllMap = Boolean(Number(allMap));

  const resultOrigin = useContextResultOrigin() || {};

  const electionPlace = town || province || community;

  if (type === TYPES.REGIONAL && isAllMap) {
    return `${PATH}${politicalParties}?year=${year ||
      resultOrigin?.primary?.year}&typeElection=${
      resultOrigin?.primary?.typeElection
    }&numElection=${resultOrigin?.primary?.numElection}&regionId=`;
  }

  return `${PATH}${politicalParties}?year=${year ||
    resultOrigin?.primary?.year}&typeElection=${
    resultOrigin?.primary?.typeElection
  }&numElection=${resultOrigin?.primary?.numElection}&regionId=${
    type === 'REGIONAL' ? electionPlace : 'C108'
  }${
    type === 'GENERAL' && subtype === 'SENATE'
      ? `&subMatchParties=true`
      : '&subMatchParties=false'
  }`;
}
